import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// Persistent app-level UI state. Per shared-docs/frontend-architecture.md:
//   - `partialize` only persists what survives reload (theme + filter + sidebar prefs).
//   - Components access via selectors: `useAppStore((s) => s.theme)`.
// `theme` is canonical (light | dark | system); the legacy `nightMode` boolean has been
// dropped — components should compute the resolved class via the App-level effect.
const useAppStore = create(
  persist(
    (set) => ({
      theme: 'system',
      setTheme: (t) => set({ theme: t }),

      sidebarOpen: false,
      setSidebarOpen: (open) => set({ sidebarOpen: open }),

      searchQuery: '',
      setSearchQuery: (q) => set({ searchQuery: q }),

      activeCategory: 'All',
      setActiveCategory: (c) => set({ activeCategory: c }),

      activeCuisine: 'All',
      setActiveCuisine: (c) => set({ activeCuisine: c }),

      activeAgeGroup: 'All',
      setActiveAgeGroup: (a) => set({ activeAgeGroup: a }),

      activeDifficulty: 'All',
      setActiveDifficulty: (d) => set({ activeDifficulty: d }),

      activeDietary: [],
      setActiveDietary: (d) => set({ activeDietary: d }),

      unitSystem: 'imperial',
      setUnitSystem: (u) => set({ unitSystem: u }),
    }),
    {
      name: 'cooksmith-app',
      partialize: (state) => ({
        theme: state.theme,
        unitSystem: state.unitSystem,
        // filters are NOT persisted — they reset per session by design
      }),
    }
  )
);

export default useAppStore;
